// Verbatim "additional info" pop-up text for the CDM/PP Personalised Care Plan.
// ONLY text lifted directly from an authoritative HSE source is kept here — the
// full field-by-field mapping (and which rows are VERBATIM vs PROPOSED) lives in
// .claude/cdm-context/careplans/care-plan-field-info-popups.md.
//   [SHEET]   = HSE PP Care Plan spreadsheet (Patient PP Care Plan Final 09/12/2022,
//               Phase III edits 05/04/23, Explanatory Note re Diabetes Link 27-12-2023, V4).
//   [CONTEXT] = .claude/cdm-context/careplans/CARE-PLANS-CONTEXT.md.

export const CARE_PLAN_INFO = {
  // [SHEET] §4A.5 / mapping row 10 — verbatim prompt examples.
  medicationConcerns:
    'Have you any questions or concerns regarding your medication? e.g. the use of an inhaler; "Nauseous when I take Drug 2".',

  // Socrates guidance (KIN-1354) — "Medication issues discussed" field.
  medicationIssuesDiscussed: [
    "Engage the patient in a conversation about their medications, including medication concordance, inhaler technique, etc.",
    {
      items: [
        "What side effects have you experienced? e.g. the use of an inhaler, nauseous when I take Drug X.",
        "What problems have you had taking your medication? e.g. Drug X must not be taken on an empty stomach — take after breakfast every day; use inhaler as demonstrated / recommended by nurse.",
      ],
    },
  ],

  // [SHEET] / mapping row 12 — verbatim.
  healthConcerns:
    "My concerns in relation to my health that were discussed with my GP / Nurse today.",

  // [CONTEXT] §4A.7 / mapping row 13 — verbatim.
  healthImprovements: "Are there areas of my health that are good or have improved?",

  // [SHEET] / mapping row 14 — verbatim.
  thingsThatMatter: "Other things that matter to me.",

  // Socrates guidance (KIN-1354) — overwrites the prior mapping-row-15 text.
  healthIssuesDiscussed: [
    "Guide the conversation by asking questions like:",
    {
      items: [
        "What concerns have you in relation to your health?",
        "Are there areas of your health that are good or improved?",
        "What other things matter to you?",
        "How do you manage your condition?",
      ],
    },
  ],

  // [SHEET] §4A.8 / mapping row 17 — verbatim field set (weight, BMI, BP, lipids
  // + HbA1c for diabetes), "for inclusion, based on discussion with patient".
  examResults:
    "Auto-populated from this review — weight, BMI, BP and lipids (plus HbA1c for diabetes) — for inclusion, based on discussion with the patient.",

  // [SHEET] §4A.11 / mapping row 20 — verbatim phrase.
  previousGoals: "Goals agreed at my last review.",

  // Socrates guidance (KIN-1354) — overwrites the prior mapping-row-21 phrase.
  currentGoals: [
    "What do you want to do / goals? What will you do? What was useful for you?",
    "These should be jointly agreed goals. Encourage the patient to choose which issue to work on first — this strengthens their commitment to take action.",
    "Consider asking:",
    {
      items: [
        "To improve their health, what would they like to achieve?",
        "What will they do to achieve their goal?",
        "What support will they need?",
      ],
    },
    "Consider barriers and enablers.",
  ],

  // Socrates guidance (KIN-1354) — "Anticipatory care plan" field (CDM only).
  anticipatoryCarePlan: [
    "Discuss the red-flag symptoms indicating a deterioration in condition that the patient needs to watch out for, and what steps to take if they detect such symptoms.",
    "Consider using self-management plans where appropriate.",
  ],

  // [SHEET] "Explanatory Note re Diabetes Link 27-12-2023" + [CONTEXT] line 177 /
  // mapping row 25b — verbatim Phase-3 explanatory note.
  diabetesLink:
    "Phase 3 — the Diabetes link (www.hse.ie/diabetes) is retained to support Gestational Diabetes (GDM) & Pre-Eclampsia.",
};

// The diabetes info link is retained specifically for GDM & Pre-Eclampsia; match
// it in the auto-populated infoLinks list by its URL.
export const isDiabetesInfoLink = (url) =>
  String(url ?? "")
    .toLowerCase()
    .includes("hse.ie/diabetes");
